<style>
	@import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Raw Materials" title="Stock Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10">
										<div class="mm-cart-text">
											<div class="col-md-6">
												<table class="product_table">
													<thead style="font-size: medium;">
														<tr>
															<th>Raw Material</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{rawMaterial.raw_material_name}}</td>
														</tr> 

														<tr>
															<th>Current Stock</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{rawMaterial.current_stock}}</td>
														
														</tr> 
													</thead>
												</table>
											</div>
                                           
                                        </div>
									</div>
                                    <div class="col-md-2">
                                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i
                                                    class='bx bx-chevrons-left'></i> Back</a>
                                    </div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchStockLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Type</th>
											<th>Stock</th>
											<th>Balance Stock</th>
											<th>Vendor</th>
											<th>Updated On</th>
                                        </tr>
									</thead>
									<tbody v-if ="Boolean(rawMaterialLogs.length)">
										<tr align="center" v-for="(material, index) in rawMaterialLogs" :key="material.id">
											<td>{{index+1}}</td>
											<td>{{ typeLabel(material.type) }}</td>
											<td>{{material.stock}}</td>
											<td>{{material.balance_stock}}</td>
											<td>{{material.vendor_name}}</td>
											<td>{{$filters.formatDate(material.updated_at)}}</td>
										</tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(rawMaterialLogs.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchStockLogs(page.url + '&limit=' + listing_length + '&raw_material_id=' + this.$route.params.id)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Tier Name<span class="text-danger">*</span></label>
                        	<input v-model="name" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Price<span class="text-danger">*</span></label>
                        	<input v-model="price" class="form-control" rows="3"/>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Validity (in months)<span class="text-danger">*</span></label>
                        	<input v-model="validity" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
                        </div>
                    </div>

					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Add Tier",
				button_title: "Add",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                button_title: "Save",
                name: "",
				validity: "",
				price: "",

				rawMaterialLogs:[],
				rawMaterial:{},
				
         		// delete: false,
         		// active_page_url: null,
			};
		},
		created() {
			this.fetchStockLogs();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchStockLogs(page_url = null) {
				this.getToken();
				let url = "/staffs/rawMaterialStockLogs?limit=" + this.listing_length  + "&raw_material_id=" + this.$route.params.id;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.rawMaterial = responseData.rawMaterial;
						this.rawMaterialLogs = responseData.rawMaterialLogs.data;
						this.pagination = responseData.rawMaterialLogs.links;
						this.from = responseData.rawMaterialLogs.from;
						this.to = responseData.rawMaterialLogs.to;
						this.total = responseData.rawMaterialLogs.total;
						
					})
					.catch((err) => console.log(err));
			},

			
			typeLabel(type) {
				const map = {
					1: 'Initial',
					2: 'Incoming',
					3: 'Outgoing',
					4: 'Deducted',
					5: "Used",
				};
				return map[type] || 'N/A';
			},
			
			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            editTier() {
                this.errors = {};
                this.name = "Diamond";
				this.price = "1000";
				this.validity = "12";
				this.modal_title = "Edit Tier";
				this.button_title = "Update";
				this.showModal();
            },
			
			clearForm() {
				this.edit = false;
                this.name = "";
				this.validity = "";
				this.modal_title = "Add Tier";
				this.button_title = "Add";
				this.errors = {};
			},


		},
	};
</script>